<template>
  <div id="serviceSku">
    <div class="faultGroup container">
      <ul class="clearfix">
        <li v-for="(item,index) in GroupLists" :key="index" class="GroupListPart listPart">
          
          <span class="exitBtn" @click.stop="exitGroup(item)">编辑</span>
          <em :class="{disabledColor:item.state !== 1,disabledColor2:item.onlineStatus !== 1}">{{item.serveName}}</em>
        </li>
        <li class="addContent" @click="newGroup()"><i class="el-icon-plus"></i></li>
      </ul>
      <el-dialog :title="textMenu[dialogMenuStatus]" :visible.sync="dislogGroup" :close-on-click-modal="false" width="600px"  @close="emptyDialog('GroupForm')">
        <el-form ref="GroupForm" :model="GroupForm" label-width="100px" :label-position="labelPosition" :rules="GroupFormRules">
          <el-form-item label="服务SKU：" prop="serveName">
            <el-input v-model.trim="GroupForm.serveName"></el-input>
          </el-form-item>
          <el-form-item label="金额：" prop="serveMoney">
            <el-input v-model.trim="GroupForm.serveMoney" placeholder="请输入金额" type="number">
              <template slot="append">.00</template>
            </el-input>
          </el-form-item>
          <el-form-item label="排序：" prop="sort">
            <el-input v-model.trim="GroupForm.sort" placeholder="请输入排序"></el-input>
          </el-form-item>
          <el-form-item label="启用状态" prop="state">
            <el-switch v-model="GroupForm.state" :active-value="1"
                       :inactive-value="-1" ></el-switch>
          </el-form-item>
          <el-form-item label="上线状态" prop="onlineStatus">
            <el-switch v-model="GroupForm.onlineStatus" :active-value="1"
                       :inactive-value="-1" ></el-switch>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer" >
            <el-button v-if="dialogMenuStatus!=='update'" type="success" @click="addEventFormSubmitBtn('GroupForm')">添加</el-button>
            <el-button v-else type="success" @click="saveEventFormSubmitBtn('GroupForm')">保存</el-button> 
            <el-button @click="emptyDialog('GroupForm')">取 消</el-button> 
          </span> 
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import {
    selectServeSku,insertServeSku,updateServeSku
    } from "../../api/api";
  export default {
  name: 'serviceSku',
  data() {
    const validateNumber = (rule, value, callback) => {
      if (/^99$|^(\d|[1-9]\d)$/.test(value) == false) {
        callback(new Error("请输入一个大于0,小于99的整数"));
      }else {
        callback();
      }
    }
    return {
      //分页变量
      pages:{
        total: 0,
        page: 1,
        pageSize: 10,
      },
      labelPosition:'left',
      dislogGroup:false,
      dialogMenuStatus: "",
      textMenu: {
        update: "修改服务SKU",
        create: "新增服务SKU"
      },
      GroupForm:{
        serveName: '',
        serveMoney: '',
        sort: '',
        state:1,
        onlineStatus:1
      },
      GroupFormRules:{
        serveName: [{ required: true, message: "请输入服务SKU名称", trigger: "blur" }],
        serveMoney: [{ required: true, message: "请输入金额", trigger: "blur" }],
        sort: [{ required: true, validator: validateNumber, trigger: 'blur' }],
      },
      GroupLists:[],
    }
  },
  components: {
  },
    mounted () {
      this.getServeSkuList();

    },
    methods: {
      //获取selectServeSku
      getServeSkuList() {
        let para={
          startRow: this.pages.page,
          pageSize: this.pages.pageSize
        }
        selectServeSku(para).then(res => {
          if (res.data.status==100) {
            this.GroupLists = res.data.results.list
          }else{
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        }).catch((error) =>{
          this.$Message.error(error.message);
        })
      },
      //清空dialog
      emptyDialog(formName) {
        this.dislogGroup = false
        this.$refs[formName].resetFields();
      },
      //新增服务
      newGroup() {
        this.GroupForm = {
          colorName: '',
          colorNumber: '',
          sort:'',
          onlineStatus:1,
          state:1,
        },
        this.dislogGroup = true
        this.dialogMenuStatus = "create";
      },
      //确定新增服务
      addEventFormSubmitBtn(formname){
        this.$refs[formname].validate((valid) => {
          if (valid) {
            // console.log(this.GroupForm)
            let para={
              serveName: this.GroupForm.serveName,
              serveMoney: this.GroupForm.serveMoney,
              sort: this.GroupForm.sort,
              onlineStatus: this.GroupForm.onlineStatus,
              state: this.GroupForm.state,
            }
            insertServeSku(para).then(res => {
              if (res.data.status==100) {
                this.$message({
                  message: res.data.message,
                  type: "success"
                });
                /*关闭弹窗，重置输入框*/
                this.dislogGroup = false;
                this.$refs[formname].resetFields();
                /*刷新*/
                this.getServeSkuList();
              }else{
                 this.$message({
                    message: res.data.message,
                    type: "error"
                  });
              }
            }).catch((error) =>{
              this.$Message.error(error.message);
            })
          } else {
            console.log('验证未通过');
            return false;
          }
        });
      },
      //编辑服务
      exitGroup(item) {
        this.dislogGroup = true
        this.dialogMenuStatus = "update";
        this.GroupForm = Object.assign({}, item);
        console.log(this.GroupForm)
      },
      //确定保存服务
      saveEventFormSubmitBtn(formname){
        this.$refs[formname].validate((valid) => {
          if (valid) {
            /*获取当前input上输入的文字*/
            let para={
              serveId: this.GroupForm.serveId,
              serveName: this.GroupForm.serveName,
              serveMoney: this.GroupForm.serveMoney,
              sort: this.GroupForm.sort,
              onlineStatus: this.GroupForm.onlineStatus,
              state: this.GroupForm.state,
            }
            updateServeSku(para).then(res => {
              if (res.status===200) {
                this.$message({
                  message: res.data.message,
                  type: "success"
                });
                /*关闭弹窗，重置输入框*/
                this.dislogGroup = false;
                this.$refs[formname].resetFields();
                /*刷新*/
                this.getServeSkuList();
              }
            }).catch((error) =>{
              this.$Message.error(error.message);
            })
          } else {
            console.log('验证未通过');
            return false;
          }
        });
      },
    },
    computed: {
    },
    watch: {

    }
}
</script>

<style lang="scss" type="text/css" scoped>
  #serviceSku{
    .clearfix{clear:both;overflow: hidden;}
    .container{padding-bottom: 20px;
      h4{margin: 15px 0;font-weight: 500;font-size: 16px;}
      .listPart{width: 140px;float: left;border:1px solid #c6c6c6;margin:0 15px 10px 0;border-radius: 10px;height: 80px;line-height: 60px;text-align: center;position: relative;z-index: 0;cursor: pointer;
        em{color: #000;font-style: normal;}
        em.disabledColor{color:#dcdfe6;}
        em.disabledColor2{color:#dcdfe6;}
        & > span:first-child{display:none;}
        span.active{position: absolute;top: -1px;right:-1px;display: block;width: 30px;height: 30px;border-width: 16px;border-style: solid;border-color: #1abc9c #1abc9c #fff #fff;border-top-right-radius:10px;
          i{position: absolute;font-size: 14px;color:#fff;top: -9px;}
        }
        span.exitBtn{position: absolute;bottom: 0;width: 100%;line-height: 20px;left: 0;border-top:1px solid #c6c6c6;z-index:1;display: block;}
      }
      .addContent{border:1px dashed #c6c6c6;width: 50px;height: 50px;line-height: 50px;float: left;text-align: center;
        margin-top: 15px;cursor: pointer;
        i{font-size: 20px;}
      }
      /*.bgShow{width: 20px;height: 20px;border-radius: 3px;display: block;}*/
    } 
  }
</style>



// WEBPACK FOOTER //
// serviceSku.vue?3e5a89b4